import { Tooltip } from '@nimbus-ds/components';
import { ProductUpdates } from '@nimbus-ds/patterns';
import { Button } from '@tiendanube/components';
import { Stack, useResponsive } from 'commons/components';
import { ActionPopover } from './components';
import { ActionProp, ActionsProps } from '../types';

interface ActionsDesktopProps extends ActionsProps {
  renderActionsAsButtons?: boolean;
}

function ActionsDesktop({
  actions,
  renderActionsAsButtons = false,
}: Readonly<ActionsDesktopProps>) {
  const { isMobile } = useResponsive(1200);
  const mainAction = actions[actions.length - 1];
  const moreActions = actions.slice(0, actions.length - 1);
  const renderMoreAsButton = moreActions.length === 1;
  const renderActionsAsSubmenu = moreActions.length > 1;
  const renderActionsAsBtns =
    renderActionsAsButtons && !isMobile && moreActions.length > 1;

  if (actions.length === 0) return null;

  const renderButtonWithOptionalPopover = (
    action: ActionProp,
    key?: number,
  ) => {
    const { productUpdates } = action;
    const button = productUpdates ? (
      <ProductUpdates
        width={productUpdates.width}
        title={productUpdates.title}
        text={productUpdates.description}
        dismissLink={productUpdates.dismissLink}
        visible={productUpdates.visible}
        onClick={productUpdates.onClick}
      >
        <Button key={key} {...action} />
      </ProductUpdates>
    ) : (
      <Button key={key} {...action} />
    );
    return action.wrapWithPopover ? (
      <action.wrapWithPopover key={key}>{button}</action.wrapWithPopover>
    ) : (
      button
    );
  };

  return (
    <Stack spacing="tight">
      {renderMoreAsButton && renderButtonWithOptionalPopover(moreActions[0])}
      {renderActionsAsBtns ? (
        moreActions.map((action, index) =>
          renderButtonWithOptionalPopover(action, index),
        )
      ) : renderActionsAsSubmenu ? (
        <ActionPopover actions={moreActions} />
      ) : null}
      {!!mainAction.tooltip && (
        <Tooltip content={mainAction.tooltip} arrow position="left">
          {renderButtonWithOptionalPopover(mainAction)}
        </Tooltip>
      )}
      {!mainAction.tooltip && renderButtonWithOptionalPopover(mainAction)}
    </Stack>
  );
}

export default ActionsDesktop;
